export const superAdminAuthModule = {
  namespaced: true,
  state: {
    isAuthenticated: !!localStorage.getItem("superAdminToken"),
    token: null,
    refreshToken: null,
    user: (() => {
      try {
        const data = localStorage.getItem("superAdminUser");
        return data ? JSON.parse(data) : null;
      } catch (e) {
        console.warn("Corrupted superAdminUser in localStorage. Clearing it.");
        localStorage.removeItem("superAdminUser");
        return null;
      }
    })(),
  },

  getters: {
    getIsAuthenticated: (state) => state.isAuthenticated,
    getToken: (state) => state.token,
    getRefreshToken: (state) => state.refreshToken,
    getUser: (state) => state.user || "",
    getPermissions: (state) => state.permissions || [],
  },
  mutations: {
    setIsAuthenticated: (state, payload) => {
      state.isAuthenticated = payload.isAuthenticated;
      state.token = payload.token;
      state.refreshToken = payload.refreshToken;
      state.user = payload.user;

      localStorage.setItem("superAdminToken", payload.token);
      localStorage.setItem("superAdminUser", JSON.stringify(payload.user));
    },
    setUser: function (state, payload) {
      state.user = payload.user;
    },
    clearPersistedState: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;

      localStorage.removeItem("superAdminToken");
      localStorage.removeItem("superAdminUser");
    },
    setPermissions: function (state, payload) {
      state.permissions = payload.permissions;
    },
  },
  actions: {
    setIsAuthenticated: ({ commit }, payload) => {
      commit("setIsAuthenticated", payload);
    },
    clearPersistedState: ({ commit }) => {
      commit("clearPersistedState");
    },
    setUser: function (context, payload) {
      context.commit("setUser", { user: payload.user });
    },
    setPermissions: function (context, payload) {
      context.commit("setPermissions", {
        permissions: payload.permissions,
      });
    },
  },
};
